<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); trackBy: trackByFunc">
		<button *ngIf="!isDefaultFilter" type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue(item)"><mat-icon color="accent" svgIcon="md:remove"></mat-icon></button>
		<copo-suggestive-item-filter [filter]="filter" [placeholder]="filter.placeholder" [filterValue]="item"></copo-suggestive-item-filter>
	</div>
</ng-container>
